<div id="divlineChart">
  <canvas id="canvas-line">{{ myChart }}</canvas>
</div>
